import { z } from 'zod';
import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
import { DisciplinaSchema, EmpleadoSchema, EmpleadosPaginadosSchema, HabilitacionSchema, NivelSchema, } from '@/data/dto/empleado';
function limpiar(values) {
    const out = {};
    for (const [k, v] of Object.entries(values)) {
        if (v === '' || v === undefined) {
            out[k] = null;
        }
        else if (k === 'comisionSolicitadoPctOverride' || k === 'comisionSolicitadoMontoOverride') {
            out[k] = v === '' ? null : Number(v);
        }
        else {
            out[k] = v;
        }
    }
    return out;
}
export const empleadosApi = {
    async listar(filtros) {
        const res = await apiClient.get(ENDPOINTS.empleados, {
            params: {
                q: filtros.q || undefined,
                activo: filtros.activo,
                pagina: filtros.pagina,
                porPagina: filtros.porPagina,
            },
        });
        return EmpleadosPaginadosSchema.parse(res.data);
    },
    async ver(id) {
        const res = await apiClient.get(`${ENDPOINTS.empleados}/${id}`);
        return EmpleadoSchema.parse(res.data);
    },
    async crear(values) {
        const res = await apiClient.post(ENDPOINTS.empleados, limpiar(values));
        return EmpleadoSchema.parse(res.data);
    },
    async editar(id, values) {
        const res = await apiClient.patch(`${ENDPOINTS.empleados}/${id}`, limpiar(values));
        return EmpleadoSchema.parse(res.data);
    },
    async desactivar(id) {
        await apiClient.delete(`${ENDPOINTS.empleados}/${id}`);
    },
    async listarHabilitaciones(id, vigentes) {
        const res = await apiClient.get(`${ENDPOINTS.empleados}/${id}/niveles`, {
            params: { vigentes },
        });
        return z.object({ items: z.array(HabilitacionSchema) }).parse(res.data).items;
    },
    async habilitar(id, v) {
        const res = await apiClient.post(`${ENDPOINTS.empleados}/${id}/niveles`, {
            nivelId: v.nivelId,
            fechaInicio: v.fechaInicio,
            observaciones: v.observaciones || null,
        });
        return HabilitacionSchema.parse(res.data);
    },
    async cerrarHabilitacion(empleadoId, habilitacionId, hasta) {
        const res = await apiClient.post(`${ENDPOINTS.empleados}/${empleadoId}/niveles/${habilitacionId}/cerrar`, { hasta });
        return HabilitacionSchema.parse(res.data);
    },
    async disciplinas() {
        const res = await apiClient.get('/api/gestion/v1/disciplinas');
        const data = res.data;
        if (Array.isArray(data))
            return z.array(DisciplinaSchema).parse(data);
        const parsed = z.object({ items: z.array(DisciplinaSchema) }).safeParse(data);
        return parsed.success ? parsed.data.items : [];
    },
    async nivelesDeDisciplina(clave) {
        const res = await apiClient.get(`/api/gestion/v1/disciplinas/${clave}/niveles`);
        const data = res.data;
        if (Array.isArray(data))
            return z.array(NivelSchema).parse(data);
        const parsed = z.object({ items: z.array(NivelSchema) }).safeParse(data);
        return parsed.success ? parsed.data.items : [];
    },
    async listarDisciplinas(activo) {
        const res = await apiClient.get('/api/gestion/v1/disciplinas', {
            params: { activo },
        });
        const data = res.data;
        const parsed = z.object({ items: z.array(DisciplinaSchema) }).safeParse(data);
        return parsed.success ? parsed.data.items : [];
    },
    async crearDisciplina(nombre, clave, orden) {
        const res = await apiClient.post('/api/gestion/v1/disciplinas', {
            nombre,
            clave,
            orden,
        });
        return DisciplinaSchema.parse(res.data);
    },
    async editarDisciplina(clave, datos) {
        const res = await apiClient.patch(`/api/gestion/v1/disciplinas/${clave}`, datos);
        return DisciplinaSchema.parse(res.data);
    },
    async desactivarDisciplina(clave) {
        await apiClient.delete(`/api/gestion/v1/disciplinas/${clave}`);
    },
    async crearNivel(disciplinaClave, nombre, orden) {
        const res = await apiClient.post(`/api/gestion/v1/disciplinas/${disciplinaClave}/niveles`, { nombre, orden });
        return NivelSchema.parse(res.data);
    },
    async disponibilidad(empleadoId, desde, hasta, excluirClaseId) {
        const res = await apiClient.get(`/api/gestion/v1/empleados/${empleadoId}/disponibilidad`, { params: { desde, hasta, excluirClaseId } });
        return res.data;
    },
};
